module.exports = __webpack_public_path__ + "img/kh2.4ec5b580.png";